import type { ModelRef } from "vue";

type ConsentElement<T> = ModelRef<boolean | T> | Ref<boolean | T>

export default function<T> (mainConsent: ConsentElement<T>, consents: ConsentElement<T>[]): Ref {

    const mainClicked = ref<boolean>();

    watch(mainConsent, (newVal) => {
        if (!mainClicked.value) return
        consents.forEach(consent => {
            consent.value = newVal
        })
    });

    watch(consents, () => {
        mainClicked.value = false;
        let areAllTrue = true;
        for (const consent of consents) {
            if (!consent.value) {
                areAllTrue = false;
                break;
            }
        }
        mainConsent.value = areAllTrue
    });

    return mainClicked;

}